import { render, staticRenderFns } from "./ggn-certificado.vue?vue&type=template&id=001e1ff7&scoped=true&"
import script from "./ggn-certificado.vue?vue&type=script&lang=js&"
export * from "./ggn-certificado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001e1ff7",
  null
  
)

export default component.exports